import React from 'react';
import { connect } from 'react-redux';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Loader from 'features/Loader/Loader';
import { getClient } from 'features/clientProfile/ducks/clientProfileActions';
import {
  getOnboardingQuestions,
  getOnboardingResponses
} from 'features/OnboardingQuestions/ducks/OnboardingQuestionsActions';
import OnboardingQuestionsContainer from './OnboardingQuestionsContainer';
import './OnboardingQuestions.scss';

class OnboardingQuestions extends React.Component {
  constructor(props) {
    super(props);
    this.clientId = props.match.params.client_id;
  }

  componentDidMount() {
    this.props.getClient(this.clientId, this.props.history);
    this.props.getOnboardingQuestions();
    this.props.getOnboardingResponses(this.clientId)
  }

  render() {
    let {
      client,
      loadingClient,
      loadingQuestions,
      onboardingQuestions,
      onboardingResponses,
      loadingResponses,
      history
    } = this.props;
    if (loadingClient || loadingQuestions || loadingResponses) {
      return(<Loader/>)
    }
    return (
      <div className="questionnaire-page">
        <div className="container">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href={`/clients/${this.clientId}`}>
              {`${client?.first_name} ${client?.last_name}`}
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Onboarding Questions</Breadcrumb.Item>
          </Breadcrumb>
          <div className="page-title">
            <h4>Onboarding Questions</h4>
          </div>
          {onboardingResponses && Object.keys(onboardingResponses).length ? (
            <OnboardingQuestionsContainer
              onboardingQuestions={onboardingQuestions}
              onboardingResponses={onboardingResponses}
              history={history}
              clientId={this.clientId}
            />
          ) : (
            <p>This Client didn't Responce to the Onboarding Questions yet!</p>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    client: state.clientProfileReducer.client,
    loadingClient: state.clientProfileReducer.loading,
    onboardingQuestions: state.OnboardingQuestionsReducer.onboardingQuestions,
    loadingQuestions: state.OnboardingQuestionsReducer.loadingQuestions,
    onboardingResponses: state.OnboardingQuestionsReducer.onboardingResponses,
    loadingResponses: state.OnboardingQuestionsReducer.loadingResponses
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getClient: (clientId, history) => dispatch(getClient(clientId, history)),
    getOnboardingQuestions: () => dispatch(getOnboardingQuestions()),
    getOnboardingResponses: clientId => dispatch(getOnboardingResponses(clientId))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingQuestions);
